import { render } from "./AdminYellowPage.vue?vue&type=template&id=07b45cc0"
import script from "./AdminYellowPage.vue?vue&type=script&lang=js"
export * from "./AdminYellowPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__